import React, { useContext, useEffect, useState } from "react";
import { HidepopupContext } from "../context/Hidepopup";
import { AiOutlineClose } from "react-icons/ai";
import { IoIosSend } from "react-icons/io";

export default function IntrestedUsers() {
  let { setHidePopUp } = useContext(HidepopupContext);
  let [email, setEmail] = useState("");
  const [message, setMessage] = useState();
  let [emailError, setEmailError] = useState(false);

  let fetures = [
    "Top Trading Insights",
    "Weekly Market Analysis",
    "Platform Tips & Tricks",
    "Trade of the Week",
    "Copy Trading Strategies",
    "Risk Management Tips",
  ];
  useEffect(() => {
    // Toggle body scroll lock
    document.body.classList.add("overflow-hidden");
    return () => document.body.classList.remove("overflow-hidden");
  }, []);

  let closePopUp = () => {
    setHidePopUp((curr) => !curr);
  };

  let formEmail = () => {
    if (email.length <= 1 || email.includes("@") === false) {
      setEmailError(true);
      setMessage('Please enter a valid email')
    return  setTimeout(() => {
        setEmailError(false);
      }, 2000);
    }
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      email,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://bridge-server1.onrender.com/api/intrested-users",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        let { message } = result;
        setMessage((curr) => curr = message);
        setEmailError(true);
        setTimeout(() => {
          setEmailError(false);
        }, 2000);
        setEmail("");
        if (result.success)
          setTimeout(() => {
            setHidePopUp((curr) => !curr);
          }, 2000);
      })
      .catch((error) => console.error(error));
  };
  return (
    <div className="fixed justify-center items-center flex flex-col w-full h-screen  bg-transparentBg z-30 overflow-hidden  ">
      <div className="bg-gradient-to-br from-black via-green-900 to-green-500  rounded-lg mx-auto flex lg:flex-row flex-col p-8 text-white ">
        <AiOutlineClose
          onClick={closePopUp}
          size={30}
          className="self-end block lg:hidden cursor-pointer "
        />
        <div className="flex-1">
          <div className="border-b border-white lg:border-r pr-8 pb-8 h-36 flex flex-col justify-center">
            <h1 className="text-start min-w-3/4 text-2xl font-bold mb-2">
              Our Free Newsletter is Launching Soon!
            </h1>
            <p className="text-start min-w-1/2">
              Get the earliest access to hand-picked content weekly for free.
            </p>
          </div>

          <div className="border-b border-white lg:border-r pr-8 pt-6 pb-8 flex flex-col justify-center">
            <ul className="flex flex-wrap lg:w-[70%] text-start items-center justify-between gap-5 mx-auto list-none">
              {fetures.map((items) => (
                <li className="text-left">{items}</li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center pl-8 border-b border-white lg:py-0 py-7">
          <AiOutlineClose
            onClick={closePopUp}
            size={30}
            className="self-end lg:-translate-y-24 lg:block hidden cursor-pointer "
          />
          <h2 className="text-2xl font-semibold">Subscribe</h2>
          <span className="lg:w-3/5 w-full relative">
            <input
              type="email"
              placeholder="Enter your email to subscribe"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-4 p-2 rounded border-none  w-full text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-400 pr-16"
            />
            <IoIosSend
              size={33}
              color="black"
              className="absolute top-5 right-6 cursor-pointer"
              onClick={formEmail}
            />
          </span>
          {emailError && (
            <small className="text-gray-300 mt-2">{message}</small>
          )}
        </div>
      </div>
    </div>
  );
}
